export const creditNumberRegExp = /^(\d{4}[- ]){3}\d{4}|\d{15}$/
export const cardExpiryDateRegExp = /^(0[1-9]|1[0-2])\/?([0-9]{2}|[0-9]{2})$/
export const CVVRegExp = /^[0-9]{3}$/
export const zipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/
